"use client";

import Link from "next/link";
import { useState } from "react";
import { Car, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const links = [
    { href: "/nabidky?body=sedan,kombi,hatchback", label: "Osobní vozidla" },
    { href: "/nabidky?fuel=elektro", label: "Elektromobily" },
    { href: "/nabidky?body=suv", label: "Užitkové" },
    { href: "#partneri", label: "Partneři" },
  ];

  return (
    <header className="sticky top-0 z-50 w-full border-b border-gray-100 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-2 font-bold text-xl text-[#1a6ef5]">
          <Car className="h-6 w-6" />
          <span>NaLeasing<span className="text-gray-400 font-normal">.cz</span></span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-6">
          {links.map((l) => (
            <Link
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-gray-600 hover:text-[#1a6ef5] transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <Link href="/partner/dashboard">
            <Button variant="outline" size="sm" className="border-[#1a6ef5] text-[#1a6ef5] hover:bg-blue-50">
              Pro partnery
            </Button>
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden p-2 text-gray-500 hover:text-gray-700"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden border-t border-gray-100 bg-white px-4 pb-4">
          {links.map((l) => (
            <Link
              key={l.href}
              href={l.href}
              className="block py-3 text-sm font-medium text-gray-600 hover:text-[#1a6ef5] border-b border-gray-50"
              onClick={() => setOpen(false)}
            >
              {l.label}
            </Link>
          ))}
          <Link href="/partner/dashboard" className="block pt-3">
            <Button variant="outline" size="sm" className="w-full border-[#1a6ef5] text-[#1a6ef5] hover:bg-blue-50">
              Pro partnery
            </Button>
          </Link>
        </div>
      )}
    </header>
  );
}
